import React from "react";
import { useNavigate } from "react-router-dom";
import "../../NewSettings.scss";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link, Menu, MenuItem } from "@mui/material";
import ChangePassword from "./ChangePassword/ChangePassword";

function PersonalSettings() {
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const [changePassword, setChangePassword] = React.useState(false);
  const [file, setFile] = React.useState("");

  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };

  const handleFileUpload = (event: any) => {
    // setFile(event.target.files[0]);
  };
  function handleChange(e: any) {
    console.log(e.target.files);
    setFile(URL.createObjectURL(e.target.files[0]));
  }
  return (
    <Box className="settingMenuWrapper">
      <ChangePassword
        attrName={setChangePassword}
        open_status={changePassword}
        value_update={updateMasterState}
      />
      <Grid container spacing={3}>
        <Grid xs={4}>
          <div className="personal_logosection">
            <h6>Profile</h6>
            <img
              src={file.length > 0 ? file : "images/boy_image.svg"}
              alt=""
              className="company_logo"
            />
            <Link className="upload_img">
              <input
                hidden
                accept="image/*"
                multiple
                type="file"
                onChange={handleChange}
              />

              <img src="images/edit_image_icon.svg" alt="" />
            </Link>
            <h5>Mr. Ankit Sachdeva</h5>
            <p>Co - Founder (Admin)</p>
          </div>
          <div className="personal_logosection">
            <h6>Profile Details</h6>
            <div className="Companydetail">
              <div className="text-left">
                <p>Gender</p>
                <h6>Male</h6>
              </div>
              <div className="text-right">
                <h4>DOB</h4>
                <h5>01/08/1991</h5>
              </div>
            </div>
            <div className="Companydetail">
              <div className="text-left">
                <p>Mobile Number</p>
                <h5>eg: +91 98565 78565</h5>
              </div>
              <div className="text-right">
                <h4>Phone Number</h4>
                <h5>0162 258963</h5>
              </div>
            </div>
            <div className="Companydetail">
              <div className="text-left">
                <p>User ID</p>
                <h6>126589875</h6>
              </div>
              <div className="text-right">
                <h4>Email ID</h4>
                <h6>Evervent.evervent.in</h6>
              </div>
            </div>
          </div>
        </Grid>

        <Grid xs={8}>
          <Grid container>
            <Grid xs={12} md={12} lg={6}>
              <div className="common_section">
                <h5>
                  Change Password
                  <span>Change password if you want</span>
                </h5>
                <Link
                  className="chng_pwd_link"
                  underline="none"
                  onClick={() => {
                    setChangePassword(true);
                  }}
                >
                  <img src="images/change_password_icon.svg" alt="" />
                  Change Password
                </Link>
              </div>
            </Grid>
            <Grid
              xs={12}
              md={12}
              lg={6}
              className="text-right"
              alignSelf="center"
            >
              <div className="signature_section">
                <h5>
                  Add Signature
                  <span>Add your signature</span>
                </h5>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileUpload}
                  hidden
                  accept="image/*"
                  multiple
                />
                <Link
                  className="upload"
                  underline="none"
                  onClick={() => {
                    if (fileInputRef.current) {
                      fileInputRef.current.click();
                    }
                  }}
                >
                  <img src="images/upload_icon.svg" alt="" />
                  Upload
                </Link>
              </div>
            </Grid>
          </Grid>

          {/* <div className="contact_details_section mb-5">
            <Grid container>
              <Grid xs={12}>
                <h5>Contact Details</h5>
                <p className="mb-3">
                  You can use the following email addresses to sign in to your
                  account and also to reset your password if you ever forget it.
                </p>
                <Grid container className="contact_details_innerBox">
                  <Grid xs={4}>
                    <span className="emailicon">
                      <img src="images/mailicon.svg" alt="" />
                    </span>
                    <h6>Email Address</h6>
                    <p>evervent.evervent.in</p>
                  </Grid>
                  <Grid xs={4} className="text-center">
                    <span className="mbNumber text-center">
                      <img src="images/phoneicon.svg" alt="" />
                    </span>
                    <h6>Mobile Number</h6>
                    <p>+91 98565 78565</p>
                  </Grid>
                  <Grid xs={4} className="text-right">
                    <span className="phNumber text-right">
                      <img src="images/callicon.svg" alt="" />
                    </span>
                    <h6>Phone Number</h6>
                    <p>0162 258963</p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div> */}
          <div className="address_details_section mb-5">
            <Grid container>
              <Grid xs={12}>
                <h5>Address</h5>
                <p className="mb-7">
                  You can use the following email addresses to sign in to your
                  account and also to reset your password if you ever forget it.
                </p>
                <Grid container className="contact_details_innerBox mb-5">
                  <Grid xs={4}>
                    <h6>Street name</h6>
                    <h5>Xyz building</h5>
                  </Grid>
                  <Grid xs={4}>
                    <h6>Area name</h6>
                    <p>ShahBad</p>
                  </Grid>
                  <Grid xs={4}>
                    <h6>State</h6>
                    <p>UP</p>
                  </Grid>
                </Grid>
                <Grid container className="contact_details_innerBox">
                  <Grid xs={4}>
                    <h6>City</h6>
                    <p>Sharanpur</p>
                  </Grid>
                  <Grid xs={4}>
                    <h6>Zip code</h6>
                    <p>178569</p>
                  </Grid>
                  <Grid xs={4}>
                    <h6>Country</h6>
                    <h5>India</h5>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
      {/* Footer Section */}
      <Grid container spacing={3} className="footerSection">
        <Grid xs={12} className="ctaBtn">
          <Button
            variant="contained"
            className="submitBtn"
            onClick={() => {
              navigate("/EditPersonalDetails");
            }}
          >
            Edit
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default PersonalSettings;
